<mat-form-field appearance="fill" class="flex w-full">
  <mat-label>Nedēļa</mat-label>
  <mat-date-range-input [rangePicker]="weekpicker">
    <input matStartDate placeholder="Sākuma datums" readonly (dateChange)="onStartDateSelected($event)" />
    <input matEndDate placeholder="Beigu datums" readonly (dateChange)="onEndDateSelected($event)" />
  </mat-date-range-input>
  <mat-datepicker-toggle matSuffix [for]="weekpicker" />
  <mat-datepicker-toggle matSuffix aria-label="Notīrīt filtru" (click)="clearDate(weekpicker)">
    <mat-icon matDatepickerToggleIcon>clear</mat-icon>
  </mat-datepicker-toggle>
  <mat-date-range-picker #weekpicker />
</mat-form-field>
